export enum CollectionPoolStatus  {   
    PendingToCreate = 1,    
    PendingUpdate = 2,
    PendingDelete = 3,
    Ready = 4,
    Failed = 5 
}